export default __webpack_public_path__ + "static/media/powertapfuels.1db4d649.png";